import { useFeatureMutation } from '@common/hooks/query/useFeatureMutation';
import { useSelectedAccount } from '@features/accounts';
import { useAuthentication } from '@features/authentication/hooks';
import { useSelectedProduction } from '@features/productions';

import { useSubmitServiceOrderMutation } from '../api/serviceOrdersApi';
import {
    BaseOrderPayload,
    OrderDeliveryItem,
    SubmitServiceOrderArgs,
} from '../types';

export const useServiceOrderAction = () => {
    const { user } = useAuthentication();
    const account = useSelectedAccount();
    const production = useSelectedProduction();

    const { execute: rawExecute, ...mutationState } = useFeatureMutation(
        useSubmitServiceOrderMutation,
    );

    const executeOrder = async (
        items: OrderDeliveryItem[],
        payload: BaseOrderPayload,
    ) => {
        const masterPayload: SubmitServiceOrderArgs<typeof payload> = {
            requester: {
                id: user.id,
                name: user.username,
                email: user.email,
            },
            context: {
                accountId: account?.id,
                accountName: account?.name,
                productionId: production?.id,
                productionName: production?.name,
            },
            items: items.map((item) => ({
                id: item.id,
                title: item.name,
            })),
            orderDetails: payload,
        };

        await rawExecute(masterPayload);

        return 'Order submitted successfully!';
    };

    return { executeOrder, ...mutationState };
};
